module.exports = __webpack_public_path__ + "static/media/Salman_Hashmi_Resume.d95e5e9f.pdf";